import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withKeys as _withKeys, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增教室")
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = { class: "dialog-footer" }

import { ref, onMounted, reactive } from "vue";
import { useI18n } from "vue-i18n";
import API from '@/apis/TPSAPI';
import { EditPen, Delete } from '@element-plus/icons-vue';
import { M_IUsers } from "@/models/M_IUser";
import { M_ICreateRuleForm, M_IUpdateRuleForm, M_IDeleteRuleForm } from '@/models/M_IRuleForm';
import { FormInstance, FormRules, ElNotification, NotificationParams, ElMessageBox  } from 'element-plus';
import {M_ICourseOptions} from "@/models/M_ICourseOptions";
import {M_IClassRoomOptions} from "@/models/M_IClassRoomOptions"; 
import { de } from "element-plus/es/locale";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassRoomMgmt',
  setup(__props) {


const isShowAddRoleDialog = ref(false);
const isShowEditRoleDialog = ref(false);
const isShowAddClassRoomDialog =ref(false);
const isShowEditClassRoomDialog = ref(false);
const { t } = useI18n();
const courseList = ref<M_ICourseOptions[]>([]);
const classRoomList = ref<M_IClassRoomOptions[]>([]);



const Error = (error: string) => {
  let notifyParam: NotificationParams = {};
  notifyParam = {
      title: "錯誤",
      type: "error",
      message: error,
      duration: 1000,
  };
}

//#region UI Events

const onEditClassRoom = async (item: M_IClassRoomOptions) => {
  console.log(item.classroomName);
  updateClassRoomForm.value?.resetFields();
  updateClassRoomFormData.classroomId = item.classroomId;
  updateClassRoomFormData.classroomName = item.classroomName;
  updateClassRoomFormData.description = item.description;
  updateClassRoomFormData.IsDelete = false;
  isShowEditClassRoomDialog.value = true;
}

const onCreateClassRoomClicked = () => {
  createaddClassRoomForm.value?.resetFields();
  isShowAddClassRoomDialog.value = true;
}

const submitClassRoomForm = async () => {
  let notifyParam: NotificationParams = {};

  createaddClassRoomForm.value?.validate(async(valid) => {
    if (valid) {
      const addClassRoom = await API.addClassroom(createClassRoomFormData);
      if (addClassRoom.data.result != 1) {
        notifyParam = {
          title: "新增失敗",
          type: "error",
          message: `${addClassRoom.data.msg}`,
          duration: 2000,
          dangerouslyUseHTMLString: true
        };
      }else{
        notifyParam = {
          title: "新增成功",
          type: "success",
          message: `教室：${createClassRoomFormData.classroomName} 已成功新增`,
          duration: 3000,
          dangerouslyUseHTMLString: true // 啟用 HTML 字符串，message 中使用<br>。
        };
      }

      ElNotification(notifyParam);
      isShowAddClassRoomDialog.value = false;
      getClassRoomsOptions();

    } else {
      console.log('error submit!')
    }
  })
};

const submitClassRoomUpdateForm = async () => {
  let notifyParam: NotificationParams = {};

  updateClassRoomForm.value?.validate(async (valid: boolean) => {
    if (valid) {
      console.log(updateClassRoomFormData);
      const updateResponse = await API.updateClassroom(updateClassRoomFormData);
      console.log(updateResponse.data.msg);

      if (updateResponse.data.result != 1) {
        notifyParam = {
          title: "編輯失敗",
          type: "error",
          message: `${updateResponse.data.msg} `,
          duration: 3000,
        };
      } else {
        notifyParam = {
          title: "編輯成功",
          type: "success",
          message: `帳號：${updateClassRoomFormData.classroomName} 已成功更新`,
          duration: 2000,
        };
          getClassRoomsOptions();
      }

      ElNotification(notifyParam);
      isShowEditClassRoomDialog.value = false;
    } else {
      console.log('error submit!');
    }
  });
};

//#endregion

//#region 建立表單ref與Validator

// 新增教室表單
const createaddClassRoomForm = ref<FormInstance>()
const createClassRoomFormData = reactive<M_IClassRoomOptions>({
  classroomName: '',
  description: ''
})

// 編輯教室表單
const updateClassRoomForm = ref<FormInstance>()
const updateClassRoomFormData = reactive<M_IClassRoomOptions>({
  classroomName: '',
  description: '',
  IsDelete: false
})

// 新增表單, 編輯表單共用規則
const rules  = reactive<FormRules>({
  classroomName: [{ required: true, message: () => t("validation_msg.classroomName_is_required"), trigger: "blur" }],
});

const editRules  = reactive<FormRules>({
  classroomName: [{ required: true, message: () => t("validation_msg.classroomName_is_required"), trigger: "blur" }],
});


//#endregion

//#region Hook functions
// onActivated(() => {
  
// });
onMounted(() => {
  getClassRoomsOptions();
  // getCourseTypeOptions();
});

//#endregion

//#region Private Functions
async function getClassRoomsOptions () {
  try {
      const response = await API.getClassrooms();
      classRoomList.value = response.data.content
      console.log(classRoomList.value)
    } catch (error) {
      console.error('載入教室資料失敗:', error);
    }
}

// async function getCourseTypeOptions () {
//   try {
//       const response = await API.getCourseType();
//       classRoomList.value = response.data.content
//       console.log(classRoomList.value)
//     } catch (error) {
//       console.error('載入課程資料失敗:', error);
//     }
// }
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 12,
          style: {"padding":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: onCreateClassRoomClicked
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_table, {
              name: "userInfoTable",
              style: {"width":"100%"},
              data: classRoomList.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "教室名稱",
                  prop: "classroomName"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "備註",
                  prop: "description"
                }),
                _createVNode(_component_el_table_column, {
                  width: "170px",
                  align: "center",
                  prop: "operate",
                  class: "operateBtnGroup d-flex",
                  label: _unref(t)('operation')
                }, {
                  default: _withCtx(({ row }: { row: any }) => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: ($event: any) => (onEditClassRoom(row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(EditPen))
                          ]),
                          _: 1
                        }),
                        _createTextVNode(_toDisplayString(_unref(t)('edit')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: isShowAddClassRoomDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isShowAddClassRoomDialog).value = $event)),
      title: _unref(t)('create')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (isShowAddClassRoomDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (submitClassRoomForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          ref_key: "createaddClassRoomForm",
          ref: createaddClassRoomForm,
          rules: rules,
          model: createClassRoomFormData,
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (submitClassRoomForm()), ["enter"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "教室",
              prop: "classroomName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createClassRoomFormData.classroomName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createClassRoomFormData.classroomName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "備註",
              prop: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createClassRoomFormData.description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createClassRoomFormData.description) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: isShowEditClassRoomDialog.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((isShowEditClassRoomDialog).value = $event)),
      title: _unref(t)('edit')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (isShowEditClassRoomDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (submitClassRoomUpdateForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          ref_key: "updateClassRoomForm",
          ref: updateClassRoomForm,
          rules: editRules,
          model: updateClassRoomFormData,
          onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (submitClassRoomUpdateForm()), ["enter"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "教室",
              prop: "classroomName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: updateClassRoomFormData.classroomName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((updateClassRoomFormData.classroomName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "備註",
              prop: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: updateClassRoomFormData.description,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((updateClassRoomFormData.description) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})